import { Button, CircularProgress } from '@mui/material';
import Grid from 'components/core/Grid';

import { StyledButton } from 'scenes/guest/styles';

interface Props {
  handleBack?: () => void;
  handleNext: () => void;
  hasBackButton?: boolean;
  isLoading?: boolean;
  isNextDisabled?: boolean;
  nextText?: string;
  backText?: string;
}

export const StepperControls = ({
  hasBackButton = true,
  handleBack = () => null,
  isLoading = false,
  handleNext,
  nextText = 'Continue',
  backText = 'Back',
  isNextDisabled = false,
}: Props) => {
  return (
    <Grid item xs={12} mt={2}>
      <Grid container spacing={2}>
        <Grid item xs={3}>
          {hasBackButton && (
            <Button variant="text" onClick={handleBack} fullWidth type="button">
              {backText}
            </Button>
          )}
        </Grid>

        <Grid item xs={9}>
          <StyledButton
            variant="contained"
            color="secondary"
            onClick={handleNext}
            fullWidth
            disabled={isNextDisabled}
            endIcon={isLoading ? <CircularProgress size={16} /> : null}
            data-testid={'linear-stepper-continue-btn'}
            type="submit"
          >
            {nextText}
          </StyledButton>
        </Grid>
      </Grid>
      <br />
    </Grid>
  );
};
